import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../../environments/environment';
import { MicrosoftOAuthService } from '../../services/microsoft-oauth.service';
import { GoogleOAuthService } from '../../services/google-oauth.service';

@Component({
    selector: 'app-link-oauth-dialog',
    templateUrl: './link-oauth-dialog.component.html',
    styleUrls: ['./link-oauth-dialog.component.scss'],
    standalone: false
})
export class LinkOAuthDialogComponent implements OnInit {
    googleLinked = false;
    /** La conexión de Google incluye Drive. Falso en cuentas vinculadas antes de unificar los flujos. */
    googleDrive = false;
    googleEmail: string | null = null;
    microsoftLinked = false;
    message = '';
    messageType = '';

    constructor(private http: HttpClient, private modalService: NgbModal, private microsoftOAuth: MicrosoftOAuthService, private googleOAuth: GoogleOAuthService) {}

    ngOnInit() {
        this.loadStatus();
    }

    private getHeaders() {
        return { headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '') };
    }

    loadStatus() {
        this.http.get(`${environment.apiUrl}/common/auth/oauth-status`, this.getHeaders())
            .subscribe((resp: any) => {
                if (resp.result) {
                    this.googleLinked = resp.result.google;
                    this.googleDrive = !!resp.result.googleDrive;
                    this.googleEmail = resp.result.googleEmail || null;
                    this.microsoftLinked = resp.result.microsoft;
                }
            });
    }

    /**
     * Conexión única: un solo consentimiento vincula la identidad y habilita Drive.
     * El backend guarda ambas cosas; acá solo refrescamos el estado.
     */
    async linkGoogle() {
        try {
            const result = await this.googleOAuth.openGoogleConnectPopup();
            this.googleLinked = true;
            this.googleDrive = true;
            this.googleEmail = result.email || null;
            this.showMessage('Cuenta de Google conectada (inicio de sesión y Drive)', 'success');
        } catch (error: any) {
            if (error?.message === 'Timeout') return;   // popup cerrado por el usuario
            this.showMessage(error?.message || 'Error al conectar Google', 'danger');
        }
    }

    async linkMicrosoft() {
        try {
            const result = await this.microsoftOAuth.openAuthPopup();
            this.linkProvider('microsoft', result.provider_id);
        } catch (error) {
            this.showMessage('Error al vincular Microsoft', 'danger');
        }
    }

    private linkProvider(provider: string, providerId: string) {
        this.http.post(`${environment.apiUrl}/common/auth/link-oauth`,
            { provider, provider_id: providerId }, this.getHeaders()
        ).subscribe({
            next: (resp: any) => {
                if (resp.result?.success) {
                    if (provider === 'google') this.googleLinked = true;
                    else this.microsoftLinked = true;
                    this.showMessage('Cuenta vinculada exitosamente', 'success');
                }
            },
            error: (err) => {
                this.showMessage(err.error?.message || 'Error al vincular cuenta', 'danger');
            }
        });
    }

    /** Desconecta identidad y Drive juntos: es una sola conexión. */
    unlinkGoogle() {
        this.http.post(`${environment.apiUrl}/common/auth/google-disconnect`, {}, this.getHeaders())
            .subscribe({
                next: (resp: any) => {
                    if (resp?.error) { this.showMessage(resp.error.message || 'Error al desvincular', 'danger'); return; }
                    this.googleLinked = false;
                    this.googleDrive = false;
                    this.googleEmail = null;
                    this.showMessage('Cuenta de Google desvinculada', 'success');
                },
                error: () => this.showMessage('Error al desvincular', 'danger')
            });
    }

    unlinkMicrosoft() { this.unlinkProvider('microsoft'); }

    private unlinkProvider(provider: string) {
        this.http.post(`${environment.apiUrl}/common/auth/link-oauth`,
            { provider, provider_id: null }, this.getHeaders()
        ).subscribe({
            next: (resp: any) => {
                if (resp.result?.success) {
                    if (provider === 'google') this.googleLinked = false;
                    else this.microsoftLinked = false;
                    this.showMessage('Cuenta desvinculada', 'success');
                }
            },
            error: () => this.showMessage('Error al desvincular', 'danger')
        });
    }

    private showMessage(msg: string, type: string) {
        this.message = msg;
        this.messageType = type;
        setTimeout(() => this.message = '', 4000);
    }

    close() { this.modalService.dismissAll(); }
}
